module.exports = __webpack_public_path__ + "static/media/lte4.91bc0127.png";